import Phaser from 'phaser';

export default class SharedPartyMenuStub extends Phaser.Scene {
  constructor() {
    super('PartyMenu');
    this.visible = false;
    this.partyButton = null;
  }

  moveCursor() {
    return false;
  }

  APressed() {
    return false;
  }

  NumPressed() {}

  EPressed() {}

  BPressed() {}

  XPressed() {}

  LBPressed() {
    return false;
  }

  RBPressed() {
    return false;
  }

  bumperPressed() {}

  setVisible(visible) {
    this.visible = visible;
  }
}
